import React, { Component } from "react";

import {
  /* CCol, */ CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CTextarea,
  CLabel,
  /* CSwitch, CRow, */ CSpinner
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  FormGroup
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import ContentComponentActivity from "../../../../components/Content/ContentActivity";
import FileCreator from "../../../../components/Content/FileCreator";
import LinkCreator from "../../../../components/Content/LinkCreator";
import UploadCreator from "../../../../components/Content/UploadCreator";
import DragAndDropActivity from "../../../../components/DragAndDrop/DragAndDropActivity";
import Loading from "../../../../components/Loading";
import ModalActivity from "../../../../components/Modal/ModalActivity";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import QuestionListCreate from "../../../../components/QuestionListCreate";
import QuestionListImportModal from "../../../../components/QuestionListImportModal/QuestionListImportModal";
import Uploader from "../../../../components/Uploader/uploader";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
// const FileDownload = require('js-file-download');

class ActivityView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      // edit: false,
      // listName: "",
      fase: 1,
      fases: 2,
      name: "",
      private: false,
      description: "",
      discipline_id: "",
      // dropDisable: true,
      disciplines_list: [],
      // contentType: "tarefas",
      activity_type: "",
      activity_types: [],
      types: [],
      types_aux: [],
      modal: false,
      creating: false,
      modalProps: {
        modalCompoent: 1, // 1- content , 2-question
        title: "",
        type: 0,
        typeName: ""
      },
      contentList: [],
      textProduction: {
        id: "",
        name: "",
        group: false,
        type: "",
        criterion: [],
        note: 0
      },
      linkModal: false,
      uploadModal: false,
      fileModal: false,
      editing: false,
      editIndex: -1,
      criterions: [],
      newTextProductionCriterion: "",
      textTypes: []
      // activity: undefined
    };

    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { id } = this.props.match.params;
    let { contentType } = this.props.match.params;
    if (contentType) {
      this.setState({
        // contentType
      });
    }

    let objDisciplinesList = {
      user_id: this.props.user.user.id
    };

    let objCriterionsList = {
      user_id: this.props.user.user.id
    };

    axios
      .all([
        axios.get(`${URL.api}content/type/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}community/room_user/list`, objDisciplinesList, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}activity/type/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}classification/discipline/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}literarte/text_types`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}literarte/criterions`, objCriterionsList, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
      ])
      .then(
        axios.spread(
          (
            respType,
            respRoomUser,
            respActivityType,
            respDiscipline,
            respTextTypes,
            respTextCriterions
          ) => {
            if (respType.data.success && respActivityType.data.success) {
              let textTypesList = [];
              respTextTypes.data.data.forEach(type => {
                textTypesList.push(type);
              });

              let textCriterionsList = [];
              respTextCriterions.data.data[0].forEach(criterion => {
                criterion.visible = true;
                textCriterionsList.push(criterion);
              });

              respTextCriterions.data.data[1].forEach(criterion => {
                criterion.visible = true;
                textCriterionsList.push(criterion);
              });

              let types = [];
              respType.data.data.forEach(type => {
                if (type.activity === true) {
                  if (type.name === "Avaliação") {
                    type.name = "Exercício";
                  }

                  if (!this.props.general.active_roles.group_id) {
                    types.push(type);
                  } else if (
                    type.id === 9 &&
                    this.props.user.user_modules?.find(
                      module => module.id === 11
                    )
                  ) {
                    types.push(type);
                  } else if (
                    this.props.user.user_modules?.find(
                      module => module.id === 2
                    )
                  ) {
                    types.push(type);
                  } else if (type.id === 18 || type.id === 12) {
                    types.push(type);
                  }
                }
              });

              let disciplinesList = [];

              if (
                ["G", "U", "R", "E"].includes(
                  this.props.general.active_roles.type
                )
              ) {
                disciplinesList = respDiscipline.data.data.map(discipline => ({
                  id: discipline.id,
                  name: discipline.name
                }));
              } else {
                let check;
                for (let i = 0; i < respRoomUser.data.data.length; i++) {
                  for (
                    let j = 0;
                    j < respRoomUser.data.data[i].disciplines.length;
                    j++
                  ) {
                    check = true;
                    for (let k = 0; k < disciplinesList.length; k++) {
                      if (
                        disciplinesList[k].id ===
                        respRoomUser.data.data[i].disciplines[j].discipline_id
                      ) {
                        check = false;
                        break;
                      }
                    }

                    if (check) {
                      disciplinesList.push({
                        id: respRoomUser.data.data[i].disciplines[j]
                          .discipline_id,
                        name: respRoomUser.data.data[i].disciplines[j]
                          .discipline_name
                      });
                    }
                  }
                }
              }

              const activityTypes = respActivityType.data.data;

              this.setState({
                types,
                types_aux: types,
                disciplines_list: disciplinesList,
                activity_types: activityTypes,
                activity_type: "1",
                discipline_id: null,
                criterions: textCriterionsList,
                textTypes: textTypesList
              });
            }
          },
          error => {
            this.error(error.response.statusText);
          }
        )
      );

    if (id) {
      this.setState(
        () => ({
          // edit: true
        }),
        () => {
          axios
            .get(`${URL.api}activity/activity/singleView/${id}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(respActivity => {
              let contentList = [];
              for (let i = 0; i < respActivity.data.data.items.length; i++) {
                let obj = {
                  type: respActivity.data.data.items[i].type_id,
                  list: {
                    id: respActivity.data.data.items[i].obj_id,
                    name: respActivity.data.data.items[i].name
                  },
                  link: respActivity.data.data.items[i].link
                };
                contentList.push(obj);
              }

              let types = [];
              if (respActivity.data.data.type_id === 3) {
                this.state.types.forEach(type => {
                  if (type.id === 12) {
                    types.push(type);
                  }
                });
              } else {
                this.state.types.forEach(type => {
                  types.push(type);
                });
              }

              this.setState(() => ({
                loading: false,
                name: respActivity.data.data.name,
                description: respActivity.data.data.description,
                discipline_id: respActivity.data.data.discipline_id,
                private: respActivity.data.data.private,
                activity_type: respActivity.data.data.type_id,
                sequential_execution:
                  respActivity.data.data.sequential_execution,
                result_type: respActivity.data.data.result_type,
                types,
                // activity: respActivity.data.data,
                contentList
              }));
            });
        }
      );
    } else {
      this.setState({
        loading: false
      });
    }
  }

  previous() {
    this.setState(state => ({
      fase: Math.max(1, state.fase - 1)
    }));
  }

  next() {
    this.setState(state => ({
      fase: Math.min(state.fases, state.fase + 1)
    }));
  }

  getAtualFase = fase => {
    this.setState({
      fase
    });
  };

  changeName = e => {
    let { value } = e.target;
    this.setState({
      name: value
    });
  };

  changeDescription = e => {
    let { value } = e.target;
    this.setState({
      description: value
    });
  };

  changePrivate = e => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      private: !this.state.private
    });
  };

  changeActivityType = e => {
    let { value } = e.target;
    let types = [];
    if (value === 3) {
      for (let i = 0; i < this.state.types.length; i++) {
        if (this.state.types[i].id === 12) {
          types.push(this.state.types[i]);
          break;
        }
      }
    } else {
      types = this.state.types_aux;
    }
    this.setState({
      activity_type: value,
      types
    });
  };

  changeDiscipline = e => {
    let { value } = e.target;
    this.setState({
      discipline_id: value
    });

    if (value != null) {
      this.setState({
        // dropDisable: false
      });
    } else {
      this.setState({
        // dropDisable: true
      });
    }
  };

  getOrder = order => {
    this.setState({
      contentList: order
    });
  };

  getSelected = selected => {
    this.setState({
      // selected
    });
  };

  selectedItem = item => {
    let contentList = [];
    this.state.contentList.forEach(list => {
      contentList.push(list);
    });

    if (item.id < 12) {
      this.setState(
        {
          modalProps: {
            // eslint-disable-next-line react/no-access-state-in-setstate
            ...this.state.modalProps,
            modalCompoent: 1,
            type: item.id,
            typeName: item.name,
            title: `Selecione - ${item.name}`
          }
        },
        () => {
          this.toggleModal();
        }
      );
    } else if (item.id === 12) {
      let check = true;
      for (let i = 0; i < contentList.length; i++) {
        if (contentList[i].type === 12 && !this.state.editing) {
          check = false;
          toastr.error(
            "Erro",
            "Você só pode adicionar uma lista de exercício na atividade."
          );
          break;
        }
      }

      if (check) {
        this.setState(
          {
            modalProps: {
              // eslint-disable-next-line react/no-access-state-in-setstate
              ...this.state.modalProps,
              modalCompoent: 1,
              type: item.id,
              typeName: item.name,
              title: `Selecione - ${item.name}`
            }
          },
          () => {
            this.toggleModal();
          }
        );
      }
    } else if (item.id === 14) {
      this.setState(
        {
          modalProps: {
            // eslint-disable-next-line react/no-access-state-in-setstate
            ...this.state.modalProps,
            modalCompoent: 1,
            type: item.id,
            typeName: item.name,
            title: `Selecione - ${item.name}`
          }
        },
        () => {
          this.toggleModal();
        }
      );
    } else if (item.id === 16) {
      this.setState({ linkModal: true });
    } else if (item.id === 17) {
      this.setState({ fileModal: true });

      /*
            this.setState({
                modalProps:{
                    ...this.state.modalProps,
                    modalCompoent:1,
                    type:item.id,
                    typeName:item.name,
                    title:'Selecione - '+item.name
                }
            },()=>{
                this.toggleModal()
            }) */
    } else if (item.id === 18) {
      this.setState({ uploadModal: true });
    } else if (this.state.editing) {
      this.setState({ editing: false });
    } else {
      this.setState(state => ({
        contentList: [
          ...state.contentList,
          { type: item.id, list: { id: -1, name: item.name } }
        ]
      }));
    }
  };

  selectedListItem = list => {
    let { id, name } = list;
    let contentList = [];
    let checkEdit = false;
    this.state.contentList.forEach(content => {
      if (content.type === 12) {
        checkEdit = true;
        content.list.id = id;
        content.list.name = name;
      }
      contentList.push(content);
    });

    if (!checkEdit) {
      let obj = {
        type: 12,
        list: {
          id,
          name
        }
      };

      contentList.push(obj);
    }

    this.setState(
      {
        contentList
      },
      () => {
        this.toggleModal();
      }
    );
  };

  editItem = (type, id, item) => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const editIndex = this.state.contentList.findIndex(
      item => item.type === type && item.list.id === id
    );

    if (type === 12) {
      this.setState({
        editListId: id,
        // cloneList: null,
        newList: false
      });
    }

    this.setState(
      {
        editing: true,
        editIndex
      },
      () => this.selectedItem(item)
    );
  };

  // Bug aqui
  removeItem = (type, id) => {
    let contentList = [];
    this.state.contentList.forEach(item => {
      if (item.type !== type || item.list.id !== id) {
        contentList.push(item);
      }
    });

    this.setState({
      contentList
    });
  };

  toggleModal = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      modal: !this.state.modal
    });
  };

  getContent = content => {
    let contentList = [];
    this.state.contentList.forEach(list => {
      contentList.push(list);
    });

    for (let i = 0; i < content.list.length; i++) {
      let check = true;
      let obj = {
        type: content.type,
        list: content.list[i]
      };

      for (let j = 0; j < contentList.length; j++) {
        if (
          content.type === contentList[j].type &&
          content.list[i].id === contentList[j].list.id
        ) {
          check = false;
          toastr.error(
            "Erro",
            `O conteúdo "${content.list[i].name}" já tinha sido adicionado antes.`
          );
          break;
        }
      }

      if (check) {
        if (this.state.editing) {
          contentList.splice(this.state.editIndex, 1, obj);
        } else {
          contentList.push(obj);
        }
      }
    }

    this.setState(
      {
        contentList
      },
      () => {
        if (![16, 18].includes(content.type)) {
          this.toggleModal();
        }
      }
    );
  };

  // Bug
  // ajusteMarvin ajustar id do objeto (verificar como vai ser feito) (verificar se vai salvar no banco)
  doneArchive = uploads => {
    let contentList = [];
    this.state.contentList.forEach(list => {
      contentList.push(list);
    });

    let obj = {
      type: 17,
      list: {
        id: uploads.split("/").reverse()[1].toLowerCase() === "repo" ? 0 : 1,
        name: uploads.split("/").reverse()[0]
      },
      link: uploads
    };

    if (this.state.editing) {
      contentList.splice(this.state.editIndex, 1, obj);
    } else {
      contentList.push(obj);
    }

    this.setState({
      contentList
    });
  };

  changeTextProductionName = e => {
    let { value } = e.target;
    this.setState({
      textProduction: {
        // eslint-disable-next-line react/no-access-state-in-setstate
        ...this.state.textProduction,
        name: value
      }
    });
  };

  changeTextProductionNote = e => {
    let { value } = e.target;
    this.setState({
      textProduction: {
        // eslint-disable-next-line react/no-access-state-in-setstate
        ...this.state.textProduction,
        note: value
      }
    });
  };

  changeTextProductionCriterionNote = (e, i) => {
    let { value } = e.target;

    let criterions = [];
    this.state.textProduction.criterion.forEach((criterion, index) => {
      if (i === index) {
        criterion.note = value;
      }
      criterions.push(criterion);
    });

    this.setState({
      textProduction: {
        // eslint-disable-next-line react/no-access-state-in-setstate
        ...this.state.textProduction,
        criterion: criterions
      }
    });
  };

  changeTextProductionCriterion = e => {
    let { value } = e.target;

    let criterions = [];
    this.state.textProduction.criterion.forEach(criterion => {
      criterions.push(criterion);
    });

    let criterionsState = [];
    this.state.criterions.forEach(criterion => {
      criterionsState.push(criterion);
      if (criterion.id === parseInt(value)) {
        criterion.note = 0;
        criterions.push(criterion);
        criterionsState[criterionsState.length - 1].visible = false;
      }
    });

    this.setState({
      criterions: criterionsState,
      textProduction: {
        // eslint-disable-next-line react/no-access-state-in-setstate
        ...this.state.textProduction,
        criterion: criterions
      }
    });
  };

  removeTextProductionCriterion = id => {
    let criterions = [];
    this.state.textProduction.criterion.forEach(criterion => {
      if (criterion.id !== id) {
        criterions.push(criterion);
      }
    });

    let criterionsState = [];
    this.state.criterions.forEach(criterion => {
      criterionsState.push(criterion);
      if (criterion.id === id) {
        criterionsState[criterionsState.length - 1].visible = true;
      }
    });

    this.setState({
      criterions: criterionsState,
      textProduction: {
        // eslint-disable-next-line react/no-access-state-in-setstate
        ...this.state.textProduction,
        criterion: criterions
      }
    });
  };

  createTextProduction = () => {
    let check = true;
    if (this.state.textProduction.name === "") {
      toastr.error("Erro", "O campo título não pode ser vazio.");
      check = false;
    }

    if (this.state.textProduction.note === 0) {
      toastr.error("Erro", "O campo nota não pode ser 0.");
      check = false;
    }

    if (this.state.textProduction.type === "") {
      toastr.error("Erro", "O campo tipo não pode ser vazio.");
      check = false;
    }

    if (this.state.textProduction.criterion.length === 0) {
      toastr.error("Erro", "O campo critério não pode ser vazio.");
      check = false;
    }

    let count = 0;
    this.state.textProduction.criterion.forEach(criterion => {
      count += Number(criterion.note.toString().replace(",", "."));
    });

    if (
      count !==
      Number(this.state.textProduction.note.toString().replace(",", "."))
    ) {
      toastr.error(
        "Erro",
        "A soma das notas dos critérios tem que ser igual a nota geral."
      );
      check = false;
    }

    if (check) {
      let obj = {
        user_id: this.props.user.user.id,
        title: this.state.textProduction.name,
        text_type_id: this.state.textProduction.type,
        note: this.state.textProduction.note,
        criterions: this.state.textProduction.criterion
      };

      axios
        .post(`${URL.api}literarte/activity_create`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          if (resp.data.success) {
            let contentList = [];
            let checkEdit = false;
            this.state.contentList.forEach(content => {
              if (content.type === 14) {
                checkEdit = true;
                content.list = {
                  id: resp.data.data,
                  name: this.state.textProduction.name
                };
              }
              contentList.push(content);
            });

            if (!checkEdit) {
              contentList.push({
                type: 14,
                list: {
                  id: resp.data.data,
                  name: this.state.textProduction.name
                }
              });
            }

            this.setState(
              {
                textProduction: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  ...this.state.textProduction,
                  id: resp.data.data
                },
                contentList
              },
              () => {
                this.toggleModal();
              }
            );
          }
        });
    }
  };

  saveActivity = () => {
    let emptyField = true;
    let obj = {
      name: this.state.name,
      description: this.state.description,
      user_id: this.props.user.user.id,
      private: false,
      discipline_id: this.state.discipline_id,
      items: this.state.contentList,
      type_id: this.state.activity_type,
      result_type: this.state.result_type,
      sequential_execution: this.state.sequential_execution
    };

    if (obj.type_id === "") {
      toastr.error("Erro", "Campo tipo vazio");
      emptyField = false;
    }

    if (obj.name === "") {
      toastr.error("Erro", "Campo nome vazio");
      emptyField = false;
    }

    if (obj.description === "") {
      toastr.error("Erro", "Campo descrição vazio");
      emptyField = false;
    }

    if (obj.private === "") {
      toastr.error("Erro", "Campo liberar atividade vazio");
      emptyField = false;
    }

    this.createActivity(obj);
  };

  createActivity = obj => {
    axios
      .post(`${URL.api}activity/activity/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            window.history.pushState(
              {},
              "",
              `/activity/create/${resp.data.data}`
            );
            if (this.state.activity_type === 3) {
              this.props.history.push(`/activity/tv/report/${resp.data.data}`);
            } else {
              this.props.history.push(`/activity/allocate/${resp.data.data}`);
            }
          } else {
            this.setState({ creating: false });
          }
        },
        () => {
          this.setState({ creating: false });
        }
      );
  };

  editActivity = obj => {
    obj.id = this.props.match.params.id;
    axios
      .post(`${URL.api}activity/activity/update`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            if (this.state.activity_type === 3) {
              this.props.history.push(`/activity/tv/report/${obj.id}`);
            } else {
              this.props.history.push(`/activity/allocate/${obj.id}`);
            }
          } else {
            this.setState({ creating: false });
          }
        },
        () => {
          this.setState({ creating: false });
        }
      );
  };

  changeNewTextProductionCriterion = e => {
    let name = e.target.value;
    this.setState({
      newTextProductionCriterion: name
    });
  };

  createTextProductionCriterion = () => {
    let obj = {
      name: this.state.newTextProductionCriterion,
      user_id: this.props.user.user.id
    };
    axios
      .post(`${URL.api}literarte/criterion_create`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          let textProductionCriterions = [];
          this.state.textProduction.criterion.forEach(criterion => {
            textProductionCriterions.push(criterion);
          });

          textProductionCriterions.push({
            id: resp.data.data,
            name: obj.name,
            user_id: this.props.user.user.id,
            value: 0
          });

          let criterions = [];
          this.state.criterions.forEach(criterion => {
            criterions.push(criterion);
          });

          criterions.push({
            id: resp.data.data,
            name: obj.name,
            user_id: this.props.user.user.id,
            visible: false
          });

          this.setState({
            newTextProductionCriterion: "",
            textProduction: {
              // eslint-disable-next-line react/no-access-state-in-setstate
              ...this.state.textProduction,
              criterion: textProductionCriterions
            },
            criterions
          });
        }
      });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  render() {
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/activity/list", to: "/activity/list" }]}
        />
        {!this.state.loading ? (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">Visualizar Atividade</h4>
                <div className="small text-muted">Visualize a Atividade</div>
              </div>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() => this.saveActivity()}
                disabled={this.state.creating}
              >
                <>
                  <span style={this.state.creating ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Fazer Cópia
                  </span>
                  {this.state.creating && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody>
              {this.state.fase === 1 ? (
                <div className="myRow">
                  <FormGroup className="mb3">
                    <CLabel>Nome da Atividade</CLabel>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-text-width" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="text"
                        value={this.state.name}
                        onChange={this.changeName}
                        placeholder="Nome da Atividade"
                        disabled
                        readOnly
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className="mb3">
                    <CLabel>Tipo</CLabel>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-text-width" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="select"
                        value={this.state.activity_type}
                        onChange={this.changeActivityType}
                        disabled
                        readOnly
                      >
                        {/* <option value=''>Escolha o tipo</option> */}
                        {this.state.activity_types.map(activityType => (
                          <React.Fragment key={activityType.id}>
                            {activityType.id === 1 ? (
                              <option value={activityType.id}>
                                {activityType.name}
                              </option>
                            ) : null}
                          </React.Fragment>
                        ))}
                        {this.state.activity_types.map(activityType => (
                          <React.Fragment key={activityType.id}>
                            {activityType.id !== 4 && activityType.id !== 1 ? (
                              <option value={activityType.id}>
                                {activityType.name}
                              </option>
                            ) : null}
                          </React.Fragment>
                        ))}
                      </Input>
                    </InputGroup>
                  </FormGroup>
                  <span className="spacer"></span>
                  <FormGroup className="mb3">
                    <CLabel>Disciplina</CLabel>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-text-width" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="select"
                        value={this.state.discipline_id}
                        onChange={this.changeDiscipline}
                        disabled
                        readOnly
                      >
                        <option value={null}>Escolha a disciplina</option>
                        {this.state.disciplines_list.map(discipline => (
                          <option key={discipline.id} value={discipline.id}>
                            {discipline.name}
                          </option>
                        ))}
                      </Input>
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className="mb3">
                    <CLabel>Tornar Pública (Opcional)</CLabel>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-text-width" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="select"
                        defaultValue={this.state.private}
                        onChange={this.changePrivate}
                        disabled
                        readOnly
                      >
                        <option value={false}>Não</option>
                        <option value>Sim</option>
                      </Input>
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className="mb3">
                    <CLabel>Descrição</CLabel>
                    <InputGroup>
                      <CTextarea
                        value={this.state.description}
                        onChange={this.changeDescription}
                        placeholder="Descrição"
                        disabled
                        readOnly
                      />
                    </InputGroup>
                  </FormGroup>
                </div>
              ) : (
                ""
              )}
              <>
                {this.state.types.length > 0 ? (
                  <>
                    <DragAndDropActivity
                      list={this.state.types}
                      list2={this.state.contentList}
                      dropDisable
                      dropArea
                      dropName="Atividades selecionadas"
                      getOrder={this.getOrder}
                      getSelected={() => null}
                      selectedItem={() => null}
                      editItem={() => null}
                      removeItem={() => null}
                      direction="horizontal"
                      dontChangeListOnSelect
                    />
                  </>
                ) : (
                  <Loading top="45" left="50" />
                )}
              </>
              <UploadCreator
                show={this.state.uploadModal}
                onClose={() =>
                  this.setState({ uploadModal: false, editing: false })
                }
                getContent={content => this.getContent(content, false)}
              />
              <LinkCreator
                show={this.state.linkModal}
                onClose={() =>
                  this.setState({ linkModal: false, editing: false })
                }
                getContent={content => this.getContent(content, false)}
              />
              {this.state.fileModal && (
                <FileCreator
                  show
                  onClose={() =>
                    this.setState({ fileModal: false, editing: false })
                  }
                  doneArchive={content => this.doneArchive(content)}
                />
              )}
              <ModalActivity
                toggleModal={this.toggleModal}
                modalState={this.state.modal}
                title={this.state.modalProps.title}
                className=" educandus modalActivity"
                backdrop="static"
                size="xl"
                noFooter
                onClose={() =>
                  this.setState({ editing: false, newList: false })
                }
              >
                {this.state.modalProps.type < 12 ? (
                  <ContentComponentActivity
                    type={this.state.modalProps.type}
                    discipline={this.state.discipline_id}
                    typeName={this.state.modalProps.typeName}
                    activity
                    typeColor={
                      this.state.types.find(
                        type => type.id === this.state.modalProps.type
                      )?.color
                    }
                    typeIcon={
                      this.state.types.find(
                        type => type.id === this.state.modalProps.type
                      )?.icon
                    }
                    getContent={content => this.getContent(content)}
                    currentRoute={this.props.currentRoute}
                  />
                ) : (
                  ""
                )}
                {this.state.modalProps.type === 12 ? (
                  this.state.newList ? (
                    <QuestionListCreate
                      newList={() =>
                        // eslint-disable-next-line react/no-access-state-in-setstate
                        this.setState({ newList: !this.state.newList })
                      }
                      history={this.props.history}
                      editListId={this.state.editListId}
                      cloneListId={this.state.cloneListId}
                      closeModal={this.closeModal}
                    />
                  ) : (
                    <QuestionListImportModal
                      selectedListChanger={this.selectedListItem}
                      newList={() =>
                        // eslint-disable-next-line react/no-access-state-in-setstate
                        this.setState({ newList: !this.state.newList })
                      }
                      history={this.props.history}
                      editList={id =>
                        this.setState({
                          editListId: id,
                          // cloneList: null,
                          newList: true
                        })
                      }
                      cloneList={id =>
                        this.setState({
                          cloneListId: id,
                          // editList: null,
                          newList: true
                        })
                      }
                    />
                  )
                ) : (
                  ""
                )}
                {this.state.modalProps.type === 14 ? (
                  <>
                    <FormGroup className="mb3">
                      <CLabel>Título</CLabel>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-text-width" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          value={this.state.textProduction.name}
                          onChange={this.changeTextProductionName}
                          placeholder="Título do texto"
                        />
                      </InputGroup>
                    </FormGroup>

                    <FormGroup className="mb3">
                      <CLabel>Pontuação máxima</CLabel>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-text-width" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="number"
                          value={this.state.textProduction.note}
                          onChange={e => this.changeTextProductionNote(e)}
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup className="mb3">
                      <CLabel>Tipo</CLabel>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-text-width" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="select"
                          value={this.state.textProduction.type}
                          onChange={e =>
                            this.setState({
                              textProduction: {
                                // eslint-disable-next-line react/no-access-state-in-setstate
                                ...this.state.textProduction,
                                type: e.target.value
                              }
                            })
                          }
                        >
                          <option value="">Escolha o tipo</option>
                          {this.state.textTypes.map(type => (
                            <React.Fragment key={type.id}>
                              <option value={type.id}>{type.name}</option>
                            </React.Fragment>
                          ))}
                        </Input>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup className="mb3">
                      <CLabel>Critérios</CLabel>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-text-width" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="select"
                          defaultValue=""
                          onChange={this.changeTextProductionCriterion}
                        >
                          <option value="">Escolha um critério</option>
                          <optgroup label="Critérios do sistema">
                            {this.state.criterions.map(criterion => (
                              <React.Fragment key={criterion.id}>
                                {criterion.visible &&
                                criterion.user_id === null ? (
                                  <React.Fragment key={criterion.id}>
                                    <option value={criterion.id}>
                                      {criterion.name}
                                    </option>
                                  </React.Fragment>
                                ) : null}
                              </React.Fragment>
                            ))}
                          </optgroup>
                          <optgroup label="Critérios do usuário">
                            {this.state.criterions.map(criterion => (
                              <React.Fragment key={criterion.id}>
                                {criterion.visible &&
                                criterion.user_id ===
                                  this.props.user.user.id ? (
                                  <React.Fragment key={criterion.id}>
                                    <option value={criterion.id}>
                                      {criterion.name}
                                    </option>
                                  </React.Fragment>
                                ) : null}
                              </React.Fragment>
                            ))}
                          </optgroup>
                        </Input>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup className="mb3">
                      <CLabel>Adicione um critério que não existe</CLabel>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-text-width" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          value={this.state.newTextProductionCriterion}
                          onChange={this.changeNewTextProductionCriterion}
                          placeholder="Digite o novo critério aqui"
                        />
                        <CButton
                          color="primary"
                          onClick={() => this.createTextProductionCriterion()}
                        >
                          Adicionar
                        </CButton>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup className="mb3">
                      <h3>Critérios escolhidos</h3>
                      {this.state.textProduction.criterion.map(
                        (criterion, index) => (
                          <div
                            key={criterion.id}
                            style={{ flexDirection: "row" }}
                          >
                            <div style={{ flexDirection: "row" }}>
                              {`- ${criterion.name} `}
                              <i
                                className="fa fa-remove"
                                style={{ color: "#F00", cursor: "pointer" }}
                                onClick={() =>
                                  this.removeTextProductionCriterion(
                                    criterion.id
                                  )
                                }
                              ></i>
                            </div>
                            <div>
                              <FormGroup className="mb3">
                                <InputGroup>
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                      <i className="fa fa-text-width" />
                                    </InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    type="number"
                                    value={criterion.note}
                                    onChange={e =>
                                      this.changeTextProductionCriterionNote(
                                        e,
                                        index
                                      )
                                    }
                                  />
                                </InputGroup>
                              </FormGroup>
                            </div>
                          </div>
                        )
                      )}
                    </FormGroup>
                    <CButton
                      color="primary"
                      onClick={() => this.createTextProduction()}
                    >
                      Criar
                    </CButton>
                  </>
                ) : (
                  ""
                )}
                {this.state.modalProps.type === 17 ? (
                  <Uploader
                    type="activity"
                    maxFiles={1}
                    allowMultiple
                    labelIdle="Clique aqui ou arraste um arquivo para cá"
                    done={uploads => this.doneArchive(uploads)}
                  />
                ) : (
                  ""
                )}
              </ModalActivity>
            </CCardBody>
          </CCard>
        ) : (
          <Loading top="45" left="50" />
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityView);
